import { render, staticRenderFns } from "./LwfPicture.vue?vue&type=template&id=c6935804&"
import script from "./LwfPicture.vue?vue&type=script&lang=js&"
export * from "./LwfPicture.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QField from 'quasar/src/components/field/QField.js';
import QAvatar from 'quasar/src/components/avatar/QAvatar.js';
import qInstall from "../../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(component, 'components', {QField,QAvatar});
